// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordChange_card__1df7c","description":"PasswordChange_description__1BJww"};